export default __webpack_public_path__ + "static/media/customer_ob.16e50b5a.svg";